import React, { useRef } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'
import GHref from 'tennders-market/common/components/element/GHref'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import { FINANCE_MODULE_INVOICE_APPROVE } from 'tennders-stracture/libs/permissions'
import useMultipleSalesInvoiceSave from 'tennders-finance/sales-invoice/hooks/useMultipleSalesInvoiceSave'
import WithdrawModal, { WithdrawModalRef } from 'tennders-finance/sales-invoice/modals/WithdrawModal'

const MultipleSalesInvoiceSaveButton = (props) => {
  const {
    lines,
    discountLines,
    extraCostsLines,
    form,
    documents,
    totalExtraCostsIncVat,
    totalEndAmountToPay,
    setFormErrors,
    setLineErrors,
    setLineForm,
    onClose,
    calculations,
    totalDiscount,
    setform,
    isCreditNote,
    paymentTermProblem,
    selectedTransaction
  } = props

  const {
    submitting,
    handleApprove,
    approving,
    handleSubmit,
    handleWithdraw
  } = useMultipleSalesInvoiceSave({
    lines,
    calculations,
    discountLines,
    extraCostsLines,
    form,
    setform,
    invoiceDocuments: documents,
    totalExtraCostsIncVat,
    totalEndAmountToPay,
    totalDiscount,
    setFormErrors,
    setLineErrors,
    setLineForm,
    onClose,
    isCreditNote,
    selectedTransaction
  })
  const onRemove = null
  const withdrawRef = useRef<WithdrawModalRef>()

  const onWithdraw = () => withdrawRef.current.show()

  const disabled = form?.status === 'approved'

  const { t } = useTranslation()

  return (
    <>
      {paymentTermProblem && (
        <div className="d-flex mb-20 justify-end color-red">
          {t('salesInvoice:payment_term_problem')}
        </div>
      )}
      {!form.toCompany?.invoiceAddress && (
        <div className="d-flex mb-20 justify-end color-red">
          {t('salesInvoice:no_address_problem')}
        </div>
      )}
      <div className="d-flex justify-space">
        {
          form.status === 'withdrawed' && form.withdrawNote
            ? (
              <div>
                <div className="text-20 color-accent-premium">
                  {t('salesInvoice:withdrawInternalComment')}
                </div>
                <div className="text-12 mt-6">
                  {form.withdrawNote}
                </div>
              </div>
            )
            : <div />
        }
        <div className="d-flex">
          <GHref
            onClick={onClose}
            className="btn-border standard-btn mr-8 bold confirm-step-btn-2"
          >
            <Trans i18nKey="common:cancel" />
          </GHref>
          {form.status === 'withdrawed' && form.withdrawEnabled ? (
            <GHref
              onClick={onRemove}
              disabled={submitting || approving}
              style={{
                backgroundColor: '#e74c3c',
                color: '#fff'
              }}
              className="btn error mr-12 bold confirm-step-btn-2"
            >
              <Trans i18nKey="salesInvoice:remove" />
            </GHref>
          ) : null}
          {form.status === 'waiting-for-approval' && (
            <RequiresPermission
              requiredPermissions={[FINANCE_MODULE_INVOICE_APPROVE]}
            >
              <GHref
                onClick={onWithdraw}
                disabled={approving || disabled}
                className="btn standard-btn mr-6 bold confirm-step-btn-2"
              >
                <Trans i18nKey="salesInvoice:withdraw" />
              </GHref>
            </RequiresPermission>
          )}
          {form.status === 'waiting-for-approval' && (
            <RequiresPermission
              requiredPermissions={[FINANCE_MODULE_INVOICE_APPROVE]}
            >
              <GHref
                submitting={submitting}
                onClick={handleSubmit}
                disabled={submitting || (isCreditNote && !form.salesInvoiceId)}
                className="btn highlighted-btn mr-6 bold confirm-step-btn-2"
              >
                <Trans i18nKey="salesInvoice:update" />
              </GHref>
            </RequiresPermission>
          )}
          {!form.approveHidden ? form.id && form.approveEnabled
            ? (
              <RequiresPermission requiredPermissions={[FINANCE_MODULE_INVOICE_APPROVE]}>
                <GHref
                  onClick={handleApprove}
                  submitting={approving}
                  disabled={approving || disabled}
                  className="btn highlighted-btn mr-6 bold confirm-step-btn-2"
                >
                  <Trans i18nKey="salesInvoice:approve" />
                </GHref>
              </RequiresPermission>
            )
            : (
              <GHref
                submitting={submitting}
                onClick={handleSubmit}
                disableHint={isCreditNote ? 'Please select a sales invoice' : null}
                disabled={paymentTermProblem || !form?.toCompany?.invoiceAddress || submitting || (isCreditNote && !form.salesInvoiceId)}
                className="btn highlighted-btn mr-6 bold confirm-step-btn-2"
              >
                <Trans i18nKey="salesInvoice:sendForApproval" />
              </GHref>
            ) : null}
        </div>
      </div>
      <WithdrawModal ref={withdrawRef} onComplete={handleWithdraw} />
    </>
  )
}

export default React.memo(MultipleSalesInvoiceSaveButton)
